import React, { useRef, useState, useCallback } from "react";
import { DialogContainer, Button } from "react-md";
import crossIcon from "../../../../../assets/icons/close-cross1.png";

export function useConfirmDialog() {
  const [dialogState, setDialogState] = useState(null);
  const resolveRef = useRef(null);

  const confirm = useCallback(
    ({ title, message, subtext, box, buttons, width }) => {
      return new Promise((resolve) => {
        resolveRef.current = resolve;
        setDialogState({ title, message, subtext, box, buttons, width });
      });
    },
    []
  );

  const handleClose = (buttonKey = null) => {
    if (resolveRef.current) {
      resolveRef.current(buttonKey);
      resolveRef.current = null;
    }
    setDialogState(null);
  };

  const getButtonStyle = (color) => {
    const baseStyle = {
      cursor: "pointer",
      marginLeft: "10px",
      minWidth: "125px",
      textTransform: "none",
      fontSize: "medium",
      borderRadius: "5px",
      color: "#FFFFFF",
    };

    switch (color) {
      case "zyOrange":
        return { ...baseStyle, backgroundColor: "#F77F11" };
      case "zyGreen":
        return { ...baseStyle, backgroundColor: "#04C9D3" };
      case "zyGrey":
        return { ...baseStyle, backgroundColor: "#EBEBEB", color: "#333333" };
      default:
        return baseStyle;
    }
  };

  const ConfirmDialog = () =>
    dialogState ? (
      <DialogContainer
        id="reusable-confirm-dialog"
        visible={true}
        focusOnMount={false}
        onHide={() => handleClose("1")}
        autosizeContent
        height="auto"
        style={{ textAlign: "left" }}
        dialogStyle={{ borderRadius: "10px", position: "relative" }}
        width={dialogState.width || "600px"}
      >
        <div
          style={{
            padding: "15px 15px 8px 15px",
            color: "black",
            fontFamily: "Montserrat",
            fontSize: "14px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <h3
                style={{
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                  whiteSpace: "normal",
                  maxWidth: "100%",
                }}
              >
                {dialogState.title}
              </h3>
            </div>
            {dialogState.buttons?.["1"] === "close" && (
              <div>
                <Button
                  plain
                  style={{
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    minWidth: "auto",
                    padding: 0,
                  }}
                  onClick={() => handleClose("1")}
                >
                  <img src={crossIcon} alt="close" height="25px" />
                </Button>
              </div>
            )}
          </div>

          {dialogState.message && <div>{dialogState.message}</div>}

          {dialogState.subtext && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "8px",
              }}
            >
              {dialogState.subtext}
            </div>
          )}

          {dialogState.box && <div>{dialogState.box}</div>}

          {Object.keys(dialogState.buttons).some((key) => key !== "1") && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                marginTop: "15px",
              }}
            >
              <div style={{ textAlign: "right" }}>
                {Object.entries(dialogState.buttons).map(([key, btn]) => {
                  if (key === "1") return null; // Skip close button
                  const label = typeof btn === "string" ? btn : btn.label;
                  const color = typeof btn === "object" ? btn.color : "zyGrey";
                  return (
                    <Button
                      key={key}
                      raised
                      style={getButtonStyle(color)}
                      onClick={() => handleClose(key)}
                    >
                      {label}
                    </Button>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </DialogContainer>
    ) : null;

  return { confirm, ConfirmDialog };
}
